import { RecordingJob, RecordingJobStatus } from "./recording-job";
import moment from "moment";

export abstract class RecordingRepository {
  updateRecordingJob: (recordingJob: RecordingJob) => Promise<string>;
  createRecordingJob: (recordingJob: RecordingJob) => Promise<string>;

  getRecordingJobs: (
    selectTop?: number,
    startDateFrom?: moment.Moment,
    startDateTo?: moment.Moment,
    recordId?: number,
    jobId?: string,
    statuses?: RecordingJobStatus[],
    orderByCreatedTimeDesc?: boolean,
  ) => Promise<RecordingJob[]>;
  deleteRecordingJob: (id: string) => Promise<boolean>;
  getRecordingMediaId: (
    recordId?: number,
    recordingJobId?: string,
    recordingSourceId?: string,
  ) => Promise<number>;
}
